import { IconCurrencyDollar } from '@tabler/icons-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export interface IViewCTCJobButtonProps
  extends Omit<IBasicButtonProps, 'children'> {
  jobNumber: string;
}

const DefaultProps: Partial<IViewCTCJobButtonProps> = {
  size: 'xs',
  leftSection: <IconCurrencyDollar size={16} />,
};

export const ViewCTCJobButton = React.memo<IViewCTCJobButtonProps>(
  ({ jobNumber, ...props }) => {
    const navigate = useNavigate();

    return (
      <BasicButton
        {...DefaultProps}
        {...props}
        onClick={() => navigate(`/ctc/view/${jobNumber}`)}
      >
        View CTC Job
      </BasicButton>
    );
  },
);
